module.exports = __webpack_public_path__ + "static/img/logo_title.07ea8e44.png";